import {
  FETCH_OUTBOUND_CALL_CAMPAIGNS_DATA_FAILED,
  FETCH_OUTBOUND_CALL_CAMPAIGNS_DATA_REQUEST,
  FETCH_OUTBOUND_CALL_CAMPAIGNS_DATA_SUCCESS,
} from './actionCreator';

const initialState = {
  data: [],
  pagination: {
    totalItems: 0,
    totalPages: 0,
    currentPage: 1,
    limit: 10,
    hasNextPage: false,
    hasPrevPage: false,
  },
  loading: false,
  error: null,
};

const outboundCallReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_OUTBOUND_CALL_CAMPAIGNS_DATA_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_OUTBOUND_CALL_CAMPAIGNS_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        pagination: action.payload.meta,
        error: null,
      };

    case FETCH_OUTBOUND_CALL_CAMPAIGNS_DATA_FAILED:
      return {
        ...state,
        loading: false,
        data: [],
        error: action.payload,
      };

    default:
      return state;
  }
};

export { outboundCallReducer };

